/**
 * Static copy for the checkout plan picker.
 */
export const PLAN_PICKER_CONFIG = {
  // Shown on every asset type, so it can't say "vehicle".
  notAvailable: 'Not available for this asset',
};
